import { useEffect, useState, useContext } from "react";
import { Box, Typography, Stack } from "@mui/material"
import { ToolContext } from "../../../../../core/context/ToolContext";
import { ComputeDays, ComputePercentage, GetPercentageFormat, StartUpperCase } from "../../global/Format";
import { UserSummary } from "../userSummary/UserSummary";
import { ActivenessChart } from "./ActivenessChart";
import { GetToolActivePercentage } from "../../../global/API";
import { ActivePercentageLoader } from "../../loader/Loader";
import moment from "moment";

export const ActivePercentage = ({__SESSION, graphDatasets, interval}) => {

    const { usage_state } = useContext(ToolContext)
    const { toolUsageData } = usage_state
    
    const [activePercentage, setActivePercentage] = useState({
        loader:false,
        average:0,
        data:[]
    })

    // const res_data_count = [7200,10,10,11]
    
    const getActivePercentage = async() => {

        const res_target = toolUsageData.data.active_threshold // transaction only

        // if (res_target > 0) { // required 
           
            setActivePercentage((prev) => ({...prev, 
                loader:true
            }))
    
            if (graphDatasets.data.dates.length > 0) {
                let no_of_days = []
                for (let i = 0; i < graphDatasets.data.dates.length; i++) {
                    let res_compute_days = await ComputeDays(graphDatasets.data.dates[i][0], graphDatasets.data.dates[i][1])
                    no_of_days.push(res_compute_days)
                }
        
                const combineArray = graphDatasets.data.label?.map((lbl, mindx) => {
                    const nod = no_of_days.find((nod, subindx) => mindx === subindx); 
                    return {label:lbl, value:nod * res_target};
                });
        
                let qsp = {
                    company_id:__SESSION.data.uaccess[0]?.company_id,
                    tool_id:parseInt(process.env.REACT_APP_TID_BIZ),
                    user_id:graphDatasets.data.assigned_id === 0 ? parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]) : graphDatasets.data.assigned_id,
                    dates:JSON.stringify(graphDatasets.data.dates)
                }
                let res_data = await GetToolActivePercentage(qsp)
                
                const finalArray = combineArray?.map((ca, mindx) => {
                    const rdc = res_data?.find((rdc, subindx) => mindx === subindx); 
                    return {...ca, count:rdc, usage:rdc? ComputePercentage(rdc, ca.value) : 0};
                });
                
                const averageUsage = finalArray?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / finalArray?.length
                
                setActivePercentage((prev) => ({...prev, 
                    data:finalArray,
                    average:GetPercentageFormat(averageUsage) || 0,
                    loader:false
                }))
            }
        // }
    }

    useEffect(() => {
        getActivePercentage()
        // eslint-disable-next-line
    }, [toolUsageData.data.active_threshold, graphDatasets.data.dates])

    return (
        <Box sx={{bgcolor: "#fff", borderRadius: 4, p:4, border: 1, borderColor: "#cececeff", width: "100%"}}>
            <Stack sx={{gap: 2}}>
                <Stack minHeight="52px" gap={1.5}>
                    <Stack direction="row" gap={1.5}>
                        <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%">Active Percentage</Typography>
                        <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5DB55D">Info</Typography>
                    </Stack>
                    <Typography fontWeight={400} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167">
                        {StartUpperCase(interval)} - {moment(graphDatasets.data.start_date).format('MMM DD')} - {moment(graphDatasets.data.last_date).format('DD, YYYY')}
                    </Typography>
                </Stack>
                <Box sx={{border: 0.5, color: "#E5E5EF"}}></Box>
                <UserSummary graphDatasets={graphDatasets} __SESSION={__SESSION} percentage={activePercentage.average} loader={activePercentage.loader}/>
                <Stack gap={3}>
                    {activePercentage.loader ? 
                        <ActivePercentageLoader/>
                    :
                        <ActivenessChart activePercentage={activePercentage}/>
                    }
                </Stack>
            </Stack>
        </Box>
    )
}